import type { FaireProductEntity } from "../../entity_types/product";

export const p_qhyzjzcyc6: FaireProductEntity = {
  token: "p_qhyzjzcyc6",
  type: "product",
  name: "Zhoug Hot Sauce (9oz)",
  brandToken: "b_uymja4qx4h",
  brandName: "Shuug",
  imageUrl:
    "https://cdn.faire.com/fastly/7c05f0c32c7d0da192a873da6a0c704d81c714d8a16070e3a2bee5a4b25894e1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c16662d9197825daec4f8402281080ad3ac603ed480e213092e951ace3c582a0.webp",
    "https://cdn.faire.com/fastly/7a8b355b47f363285decf38d9d17c796ce6003ee1124d2107e8f0af8cdb1ca97.webp",
    "https://cdn.faire.com/fastly/6324d9ff53459899a2ac9a7e8e07dd298136382cc16e712220ad72f74eb491a6.webp",
    "https://cdn.faire.com/fastly/070f0d90a443d933957c6da5c17004cdf93df90a16e002530040d698a0d0a77a.png",
    "https://cdn.faire.com/fastly/cb6d946e1aacba9849d7a5a451305a840652b10c35fd171ff0128c77b83bc379.webp",
    "https://cdn.faire.com/fastly/946e078963df49437eb12a72f9576f27057adf5844762d1a58dbe88d9dc7101d.webp",
    "https://cdn.faire.com/fastly/eb5825ef41d7fbce2257296d431d80e9374a302e282e8650182f3f8817cf611a.webp",
    "https://cdn.faire.com/fastly/bef06080d8edfe4519d2b72e693dccdbf08147e66332281c625514420c783ad0.webp",
    "https://cdn.faire.com/fastly/20ed82257e0c75b2ef777f83ab1731d4b86a726319e8b1f4b50388c0a98da7c4.png",
  ],
  priceDollars: 6.95,
  description:
    "The Mid-Med Sriracha\n\nElevate your dishes with Shuug, a squeezable hot sauce made with fresh scotch bonnet, poblano, and jalapeño peppers. Inspired by traditional family recipes, our sauce delivers a zesty heat that enhances any dish. Perfect for drizzling over eggs, spicing up sandwiches, or adding depth to dinner entrees, Shuug’s versatility makes it an essential addition to any kitchen.\n\n• Authentic Flavor\n• Versatile Use\n• High-Quality Ingredients\n• Non-GMO, Gluten-Free, Vegan, and Kosher Certified\n\nAttract food enthusiasts with this bold, flavorful hot sauce. Available in cases of 12 9oz bottles. Bring the taste of the Middle Eastern & Mediterranean regions to your customers with Shuug!",
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:36.127Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
